import React, { useState } from "react";
import { Empty, Spin } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../../Components/Items";
import ListaConversaciones from "./ListaConversaciones";
import HiloMensajes from "./HiloMensajes";
import useChatWhatsapp from "./useChatWhatsapp";
import ModalNuevaConversacion from "../ModalNuevaConversacion";
import ModalMensajeMasivo from "../ModalMensajeMasivo";
import { WA } from "../../theme";

const BandejaWhatsapp = ({
  headersToken,
  empresaId,
  permisoConfiguracionWhatsapp,
  permisoElementosWhatsapp,
  permisoGuardarImagenInsumo,
  permisoMensajeMasivo,
  permisoVerChatsOtros,
  permisoContestarChatsOtros,
  permisoTraspasarChats,
  onIrAConfiguracion,
}) => {
  const [modalNueva, setModalNueva] = useState(false);
  const [modalMasivo, setModalMasivo] = useState(false);

  const {
    conexionActiva,
    conversaciones,
    conversacionActiva,
    mensajes,
    loadingConversaciones,
    loadingMensajes,
    enviando,
    esMaster,
    hayMas,
    cargandoMas,
    seleccionarConversacion,
    cargarMasMensajes,
    enviarMensaje,
    enviarMediaArchivo,
    enviarPlantilla,
    enviarServicio,
    iniciarYEnviarPlantilla,
    enviarPlantillaMasiva,
    vincularContacto,
    derivarConversacion,
    numeroPorUsuario,
    puedeVerOtros,
    puedeDerivar,
    miLineaId,
    miNumero,
    lineaPrincipalId,
  } = useChatWhatsapp({ headersToken });

  const lineaActiva = conversacionActiva?.lineaWhatsappId;
  const esMiLinea =
    !numeroPorUsuario ||
    (!!miLineaId && String(lineaActiva?._id || lineaActiva || "") === String(miLineaId));
  const esDelBuzon =
    !!lineaPrincipalId &&
    String(lineaActiva?._id || lineaActiva || "") === String(lineaPrincipalId);
  const numeroEnvioActivo = lineaActiva?.numeroDisplay || null;
  const duenoNumeroActivo = lineaActiva?.usuarioId
    ? [
        lineaActiva.usuarioId.nombre,
        lineaActiva.usuarioId.apellidoPaterno,
        lineaActiva.usuarioId.apellidoMaterno,
      ]
        .filter(Boolean)
        .join(" ")
    : null;

  if (conexionActiva === null) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: 40,
          backgroundColor: WA.surface,
          borderRadius: 12,
        }}
      >
        <Spin />
      </div>
    );
  }

  if (conexionActiva === false) {
    return (
      <div
        style={{
          border: `1px solid ${WA.border}`,
          borderRadius: 12,
          backgroundColor: WA.surface,
          padding: 40,
          textAlign: "center",
        }}
      >
        <Empty
          image={<WhatsAppOutlined style={{ fontSize: 48, color: WA.lima }} />}
          description="WhatsApp no está conectado."
        />
        {permisoConfiguracionWhatsapp && (
          <ButtonItem lima style={{ margin: "12px auto 0" }} onClick={onIrAConfiguracion}>
            Ir a Configuración
          </ButtonItem>
        )}
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          height: "calc(100vh - 180px)",
          border: `1px solid ${WA.border}`,
          borderRadius: 12,
          overflow: "hidden",
          backgroundColor: WA.surface,
        }}
      >
        <div
          className="wa-scroll-verde"
          style={{
            width: 320,
            borderRight: `1px solid ${WA.border}`,
            overflowY: "auto",
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ListaConversaciones
            conversaciones={conversaciones}
            loading={loadingConversaciones}
            conversacionActivaId={conversacionActiva?._id}
            onSelect={seleccionarConversacion}
            esMaster={esMaster}
            onNuevaConversacion={() => setModalNueva(true)}
            onMensajeMasivo={permisoMensajeMasivo ? () => setModalMasivo(true) : undefined}
            permisoMensajeMasivo={permisoMensajeMasivo}
            numeroPorUsuario={numeroPorUsuario}
            puedeDerivar={puedeVerOtros && permisoVerChatsOtros}
            miLineaId={miLineaId}
            miNumero={miNumero}
            lineaPrincipalId={lineaPrincipalId}
            numeroEnvioActivo={numeroEnvioActivo}
            duenoNumeroActivo={duenoNumeroActivo}
          />
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
          <HiloMensajes
            conversacion={conversacionActiva}
            mensajes={mensajes}
            loading={loadingMensajes}
            enviando={enviando}
            onEnviar={enviarMensaje}
            onEnviarMedia={enviarMediaArchivo}
            onEnviarServicio={enviarServicio}
            onEnviarPlantilla={enviarPlantilla}
            headersToken={headersToken}
            empresaId={empresaId}
            puedeGuardarPlantilla={permisoElementosWhatsapp}
            puedeGuardarImagenInsumo={permisoGuardarImagenInsumo}
            hayMas={hayMas}
            cargandoMas={cargandoMas}
            onCargarMas={cargarMasMensajes}
            onVincularContacto={vincularContacto}
            numeroPorUsuario={numeroPorUsuario}
            puedeDerivar={puedeDerivar && esDelBuzon && permisoTraspasarChats}
            puedeEscribir={esMiLinea || permisoContestarChatsOtros}
            onDerivar={derivarConversacion}
          />
        </div>
      </div>

      <ModalNuevaConversacion
        visible={modalNueva}
        headersToken={headersToken}
        empresaId={empresaId}
        onIniciarYEnviar={(telefono, fd, onExito, contactoId) =>
          iniciarYEnviarPlantilla(
            telefono,
            fd,
            (conv) => {
              seleccionarConversacion(conv);
              onExito?.();
            },
            contactoId,
          )
        }
        onCancel={() => setModalNueva(false)}
      />

      <ModalMensajeMasivo
        visible={modalMasivo}
        headersToken={headersToken}
        empresaId={empresaId}
        onEnviarMasivo={enviarPlantillaMasiva}
        onCancel={() => setModalMasivo(false)}
      />
    </>
  );
};

export default BandejaWhatsapp;
